import React from 'react'
import { useStatusReportContext } from './statusReportContext'
import ClientStatusReportSummaryDefaultLayout from './layouts/DefaultLayout/ClientStatusReportSummaryDefaultLayout'
import ClientStatusReportSummaryBoardLayout from './layouts/BoardLayout/ClientStatusReportSummaryBoardLayout'

function ClientStatusReportSummary (props) {
  const { variant } = useStatusReportContext()

  if (variant === 'board') {
    return <ClientStatusReportSummaryBoardLayout {...props} />
  }

  return <ClientStatusReportSummaryDefaultLayout {...props} />
}

export default ClientStatusReportSummary
